'use client';

import { useMemo, useState } from 'react';
import type { BillingCycle, BillingPlan } from '@/lib/api';
import { CycleToggle } from './CycleToggle';
import { PlanCard } from './PlanCard';
import { buildCycleOptions } from './pricing-model';

/**
 * Vitrine de planos com seletor de ciclo. Recebe os planos (ja carregados do
 * backend) e gere o estado do ciclo selecionado localmente. O toggle so
 * aparece quando ha ciclo longo configurado; caso contrario mostra so o
 * mensal - identico ao comportamento anterior da pagina.
 */
export function PricingPlans({
  plans,
  trialDays,
}: {
  plans: BillingPlan[];
  trialDays: number;
}) {
  const options = useMemo(() => buildCycleOptions(plans), [plans]);
  const [cycle, setCycle] = useState<BillingCycle>('MONTHLY');

  // Se o ciclo selecionado deixou de existir nas opcoes (dados mudaram),
  // cai pro mensal - sempre presente.
  const activeCycle = options.some((o) => o.cycle === cycle) ? cycle : 'MONTHLY';

  return (
    <>
      {options.length > 1 && (
        <div className="pricing-toggle-wrap">
          <CycleToggle options={options} value={activeCycle} onChange={setCycle} />
        </div>
      )}

      <div className="pricing-grid">
        {/* "Mais popular" vem da flag Plan.featured (DB, editavel em
            /admin/plans) - nunca de um code de plano hardcoded. */}
        {plans.map((plan) => (
          <PlanCard
            key={plan.code}
            plan={plan}
            cycle={activeCycle}
            popular={plan.featured}
            trialDays={trialDays}
          />
        ))}
      </div>
    </>
  );
}
